export default "__VITE_ASSET__Byx3nF3U__"